"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentAndClassPerformance: {
        title: 'Student and Class Performance',
        averageScore: 'Average Score',
        ariaLabel: 'Graphical view for student and class performance',
    },
};
